import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'

export function isCampaignAccessible(campaign, featureFlags) {
  if (campaign.type !== campaignTypeEnum.TYPE_WORKFLOW) {
    return true
  }

  if (!featureFlags.maxautomation) {
    return false
  }

  // Treat undefined/null new_mxa as 0 (JB1 for backwards compatibility)
  const mxaVersion = campaign.new_mxa != null ? campaign.new_mxa : 0

  if (mxaVersion === 0) {
    return featureFlags.legacyMxaEnabled
  }

  if (mxaVersion === 1) {
    return featureFlags.newMxa
  }

  return false
}



// WEBPACK FOOTER //
// ./src/modules/campaigns/helpers/CampaignPermissions.js